import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "label__spec-name"
}
const _hoisted_3 = {
  key: 1,
  "data-wow-delay": ".15s"
}
const _hoisted_4 = { class: "list-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_ctx.isNotEmpty())
    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.options, (option, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          id: "feature-wrapper",
          class: _normalizeClass(["features__list-label tooltip__info", {
            label__spec: _ctx.showLabel,
            'wow fadeIn': !_ctx.disableWowEffect,
            tooltip__info: !_ctx.showLabel,
            'label__spec--without-icon': !option.icon_href,
        }]),
          "data-wow-delay": ".15s",
          key: index,
          style: _normalizeStyle({
            border: option.icon_href && !_ctx.showLabel ? 'none' : undefined,
            padding: !_ctx.showLabel ? 'unset' : undefined,
        })
        }, [
          (option.icon_href)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                id: "feature-img",
                src: option.icon_href,
                class: "sprite-icon features__list-icon label__spec-icon",
                alt: ""
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true),
          (_ctx.showLabel)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(option.name), 1))
            : _createCommentVNode("", true)
        ], 6)), [
          [_directive_tippy, !_ctx.showLabel && { content: option.name, interactive: true }]
        ])
      }), 128))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _createVNode(_component_i18n_t, { keypath: "carDetails.mainFeaturesAreNotAvailable" })
        ])
      ]))
}